var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76843 25.0721L19.9381 25.0729L20.1716 6.21492M4.76843 25.0721C3.37611 25.0548 1.0078 24.3952 1.02976 22.622C1.05172 20.8488 1.2613 3.92252 1.2613 3.92252M4.76843 25.0721L4.88518 15.643L5.00193 6.21404M20.1716 6.21492L5.00193 6.21404M20.1716 6.21492C18.8028 4.69055 17.5162 3.92252 18.0666 1.20695C11.8136 1.12952 10.4723 1.28438 4.21927 1.20695C2.24707 1.18253 1.28423 2.07595 1.2613 3.92252M5.00193 6.21404C2.00195 6.21492 1.53377 5.12632 1.2613 3.92252M8.50195 11.3139L16.4152 11.3139",
    stroke: "#EFF3F7",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoc);
export default __webpack_public_path__ + "static/media/icon_doc.eb026ad17131105b566bb034ccbfde6f.svg";
export { ForwardRef as ReactComponent };